
export default {
  props: {
    instance: Object,
    index: Number,
    _destroy: Number
  },
  computed: {
    base_input_name: function () {
      return 'instance'
    },
    base_input_id: function () {
      return 'instance'
    }
  },
  methods: {
    inputName: function (attribute) {
      return `${this.base_input_name}[${this.index}][${attribute}]`
    },
    inputId: function (attribute) {
      return `${this.base_input_id}_${this.index}_${attribute}`
    },
    remove: function () {
      this.$emit('event-remove-instance', this)
    }
  }
}